import { Box, Spinner, SpinnerProps, BoxProps } from "@chakra-ui/react";
import React from "react";

interface AppLoaderProps extends SpinnerProps {
  boxProps?: BoxProps;
}

const AppSpinner: React.FC<AppLoaderProps> = ({
  size = "xl",
  color = "white.500",
  boxProps = {},
  ...spinnerProps
}) => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" {...boxProps}>
      <Spinner size={size} color={color} {...spinnerProps} />
    </Box>
  );
};

export default AppSpinner;
